var ostbv = ostbv || {};

ostbv.navigation = new function () {

    var self = this, 
        menuTrigger = $('#hamburger-icon'),
        subnavTrigger = $('.subnav-trigger', '#nav-header'),
        activeItem = $('.active', '#nav-header');


    this.init = function () {
        // Bind the menu-button on init.
        self.triggerMenu(menuTrigger);
        // Bind the submenu triggers on init.
        self.openSubMenu(subnavTrigger);
        // Check for active class
        if ( (novicell.responsive.isXs() || novicell.responsive.isSm()) && activeItem.length > 0 ) {
            activeItem.parents('li').addClass('opened').find('ul').show();
        }
    };

    this.triggerMenu = function (t) {
        t.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Toggle body class
            t.toggleClass('active');
            $('html').toggleClass("menu-open");
        });
    };

    this.openSubMenu = function (t) {
        t.click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $openItem = $('.opened', '#navigation-list'),
                $parentLi = $this.parents('li');
                $parentOpenItem = $parentLi.filter('.opened');


            // Open submenu
            if ($this.is('button') && !$parentLi.hasClass('opened')) {
                // Close open items, but not our parent
                $openItem.not($parentOpenItem).removeClass('opened').find('ul').slideUp('fast');
                $this.parent().next().slideToggle('fast');
            }

            else if ($this.is('button') && $parentLi.hasClass('opened')) {
                $this.parent().next().slideToggle('fast');
            }

            $this.closest('li').toggleClass('opened');
        });
    };

    this.dropdown = function(selector) {
        if(novicell.responsive.isMd() || novicell.responsive.isLg()){
            $(selector).hoverIntent( {
                timeout: 200,
                over: function(){ $(this).toggleClass('show-dropdown') },
                out: function () { $(this).toggleClass('show-dropdown'), console.log('out-trigger') }
            });
        }
    };

};